import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CelebrationModel} from "../../models/modelsCelebration";
import {selectCelebration,
        consumeCelebration} from "./celebrationsSlice";
import {CelebrationComponent} from "../../components/celebrations/Celebration";

export const CelebrationHost = () => {

  const dispatch = useDispatch();
  const next = useSelector(selectCelebration) ?? null; // first in queue

  const [play, setPlay] = useState<{ trigger: number; celebration: CelebrationModel | null }>({
          trigger: 0,
          celebration: null,
  });

  useEffect(() => {
    if (!next) return;
    setPlay((p) => ({ trigger: p.trigger + 1, celebration: next }));
    dispatch(consumeCelebration(1)); // slice reducer from my last message
  }, [next, dispatch]);

  return (
    <CelebrationComponent
       trigger={play.trigger}
       celebration={play.celebration}
    />
  )
};
